import axios from '@/util/axios';

export default [...axios.defaults.transformResponse, (data) => (!data.errors ? data.data : data)];
